export default {
      id: "chevron-right-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#chevron-right",
      toString: function () {
        return this.url;
      }
    }